module.exports = __webpack_public_path__ + "assets/img/hr-logo-text.40896323.png";